import type { Props as BannerProps } from '@rover/kibble/patterns/Banner';

export type Props = BannerProps & { autoHideDuration?: number };

export type ToastHandle = {
  dismiss: () => void;
};

export const defaultProps = {
  autoHideDuration: 8000,
};
